import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../Layout/DocumentationSidebar";
import TopMenu from "./TopMenu";
import TableDocument from "./TableDocument";
import FilterModal from "../../Components/Common/FilterModal";
import { get } from "../../utils/api";
import Unauthorized from "../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../context/AuthContext";

const Social = () => {
  const { user } = useUser();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [travelFilter, setTravelFilter] = useState({
    title: "",
    status: "",
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: 10,
      }).toString();

      const response = await get(
        `/social/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}&search=${searchQuery}`
      );
      console.log("response document", response.data.data);
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      setPage(response?.data?.currentPage);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate,searchQuery ]);

  const fetchFilter = async () => {
    try {
      const response = await get(`/social/filter`);
      console.log("response", response);
      setTravelFilter({
        title: response.data?.data?.title,
        status: response.data?.data?.status,

      });
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchFilter();
    console.log("searchQuery", searchQuery);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    console.log("response data",)
  };

  const heading = [
    {
      title: "Date",
      key: "createdAt",
    },
    {
      title: "Title",
      key: "title",
    },
    {
      title: "Status",
      key: "status",
    }


  ].filter(Boolean);

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Title",
      type: "option",
      key: "title",
      value: travelFilter?.title
        ? travelFilter.title
        : [],
        title: "Status",
        type: "option",
        key: "status",
        value: travelFilter?.status
        ? travelFilter.status
        : [],
    },
   
  ].filter(Boolean);

  const toggleData = [];
  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
        <TopMenu
          {...{
            setDrawerFilterOpen: setIsFilterModalOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSelectedYear,
            selectedOption,
            handleToggle,
             searchQuery,
             setSearchQuery,
            filterApplied: isFiltersApplied,
            toggleData: toggleData,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
             facilityRequired: "false"
          }}
          heading={"Social"}
        />

        <TableDocument
          data={data}
          totalPages={totalPages}
          page={page}
          handleChangePage={handleChangePage}
          headers={heading}
          columnWidth={
             "25% 25% 25% 25%"
          }
          documnets={["documents"]}
          // tableContainerRef={tableContainerRef}
        />

        <FilterModal
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          filters={filterData}
          onFilterChange={handleFilterChange}
          title="Filter"
        />
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default Social;
